var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "justify-content-end", attrs: { "no-gutters": "" } },
    [
      _c(
        "b-col",
        { staticClass: "mb-3 mb-lg-0", attrs: { cols: "6", md: "auto" } },
        [
          _c(
            "b-button",
            _vm._b(
              {
                staticClass: "ml-md-2 ml-0 btn-sm",
                attrs: { variant: "white" },
                on: { click: _vm.handleClearSelection },
              },
              "b-button",
              _vm.clearSelectionProps,
              false
            ),
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("application-reports.clearSelection")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showCalculate
        ? _c(
            "b-col",
            { staticClass: "mb-3 mb-lg-0", attrs: { cols: "6", md: "auto" } },
            [
              _c(
                "simple-button",
                _vm._b(
                  {
                    staticClass: "ml-md-2 ml-0",
                    attrs: {
                      "class-name": "btn-sm",
                      type: "white",
                      disabled: _vm.hasErrors,
                    },
                    on: { click: _vm.handleSetDefault },
                  },
                  "simple-button",
                  _vm.setDefaultProps,
                  false
                ),
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("financial-tools.calculate")) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showPreview
        ? _c(
            "b-col",
            { staticClass: "mb-3 mb-lg-0", attrs: { cols: "6", md: "auto" } },
            [
              _c(
                "simple-button",
                _vm._b(
                  {
                    staticClass: "ml-md-2 ml-0",
                    attrs: {
                      type: "primary",
                      loading: _vm.isLoading,
                      disabled: _vm.hasErrors,
                    },
                    on: { click: _vm.handleRunReport },
                  },
                  "simple-button",
                  _vm.reportProps,
                  false
                ),
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("global.words.preview")) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }